import React from "react";
import Case from "./functions/functions.js"
import DownloadFile from "./DownloadFile.js"


export default function Table({ setState, state }) {

    const mass = parseFloat(state.mass)
    const M = parseFloat(state.M)
    const l = parseFloat(state.l)
    const alpha = parseFloat(state.alpha)
    const beta = parseFloat(state.beta)
    const name = state.name

    const res = new Case(name, mass, M, l, alpha, beta)

    const weight = res.weight
    const d = res.d
    const D = res.D
    const muscleForce = res.muscleForce
    const hipJRFmagnitude = res.hipJRFmagnitude
    const hipJRFangle = res.hipJRFangle
    const hipJRFboyweights = (hipJRFmagnitude / weight).toFixed(1)

    const results = {
        weight: weight,
        d: d,
        D: D,
        muscleForce: muscleForce,
        hipJRFmagnitude: hipJRFmagnitude,
        hipJRFangle: hipJRFangle,
        hipJRFboyweights: hipJRFboyweights
    }

    const data = Object.assign(state, results)


    return (
        <div className="container">
            <p></p>
            <h1 className="text-center">
                Results
            </h1>
            <div className="d-flex flex-column flex-md-row">
                <div className="rounded col-md-6">
                    <table className="table table-bordered bg-light">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">3</th>
                                <td>abductors' lever arm (cm)</td>
                                <td>{d}</td>
                            </tr>
                            <tr>
                                <th scope="row">4</th>
                                <td>weight lever arm (cm)</td>
                                <td>{D}</td>
                            </tr>
                            <tr>
                                <th scope="row">2</th>
                                <td>cumulative force of abductors (N)</td>
                                <td>{muscleForce}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
ß
                <div className="col-md-6">
                    <table className="table table-bordered bg-light">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row" className="bg-primary text-white">5</th>
                                <td className="bg-primary text-white">hip JRF magnitude (N)</td>
                                <td className="bg-primary text-white">{hipJRFmagnitude}</td>
                            </tr>
                            <tr>
                                <th scope="row" className="bg-primary text-white">5</th>
                                <td className="bg-primary text-white">hip JRF magnitude relative bodyweight</td>
                                <td className="bg-primary text-white">{hipJRFboyweights}</td>
                            </tr>
                            <tr>
                                <th scope="row" className="bg-primary text-white">6</th>
                                <td className="bg-primary text-white">hip JRF angle with horizontal</td>
                                <td className="bg-primary text-white">{hipJRFangle}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="d-flex justify-content-center">
                <DownloadFile state={data} />
            </div>

        </div>
    )
}
